module.exports = __webpack_public_path__ + "static/media/3.692a5370.jpg";